/**
 * A letter's one status (`letterStatus`), drawn the same everywhere: a badge only when it is Done
 * or the BP has to act, plain grey text otherwise — colour that means something.
 */
import { Badge } from '@finn-auto/design-system/atoms/badge';
import { cn } from '../../../../shared';
import type { LetterStatus } from './letterStatus';

const VARIANT = { done: 'green', alert: 'red', warn: 'orange' } as const;

/** The status as a badge or as text; `className` sizes it for where it sits. */
export function LetterStatusBadge({ status, className }: { status: LetterStatus; className?: string }) {
  if (status.tone === 'plain') {
    return <span data-testid="letter-status" className={cn('inline-flex items-center whitespace-nowrap text-sm text-zinc-600', className)}>{status.label}</span>;
  }
  return <Badge data-testid="letter-status" variant={VARIANT[status.tone]} className={cn('whitespace-nowrap', className)}>{status.label}</Badge>;
}
